<template>
  <div class="receive-coupon-popup">
    <center-popup :show.sync="visible">
      <div class="popup-content"
           :class="{ 'disabled': status === 'hasReceived' }"
      >
        <div class="title">{{ content.title }}</div>
        <img class="coupon-img"
             :src="content.src"
             alt="coupon"
        >
        <div class="hint">快去给孩子选课吧</div>
        <a class="join-btn"
           href="/marketing/2019/scholarship/plan#products"
           @click="handleJoinCourse"
           v-ym-report:MARKETING_SCHOLARSHIP_2019_USE_COUPON_CLICK
        >
          马上选课
        </a>
      </div>
    </center-popup>
  </div>
</template>

<script>
  import CenterPopup from '@/components/CenterPopup';

  export default {
    name: 'ScholarshipPlanReceiveCouponPopup2019',
    components: {
      CenterPopup,
    },
    props: {
      status: {
        type: String,
        required: true,
      },
      show: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        visible: false,
        receiveSuccess: {
          title: '恭喜你已成功领取奖学金',
          /* eslint-disable global-require */
          src: require('@/pages/2019/ScholarshipPlan/assets/img/receive_success.png'),
        },
        hasReceived: {
          title: '你已领取过该奖学金',
          /* eslint-disable global-require */
          src: require('@/pages/2019/ScholarshipPlan/assets/img/has_received.png'),
        },
      };
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    computed: {
      content() {
        if (this.status === 'hasReceived') return this.hasReceived;
        return this.receiveSuccess;
      },
    },
    methods: {
      handleJoinCourse() {
        this.visible = false;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .title {
    line-height: 1;
    font-size: 38px;
    font-weight: @font-weight-bold;
    color: #bc4e1d;
    text-align: center;
  }

  .coupon-img {
    margin: 64px auto 56px;
    width: 460px;
    height: 238px;
    display: block;
  }

  .hint {
    margin-bottom: @size-base;
    line-height: 1;
    font-size: @font-size-base;
    color: #bb4d1d;
    text-align: center;
  }

  .join-btn {
    display: block;
    width: 550px;
    height: 90px;
    margin: 0 auto;
    background: linear-gradient(to bottom, rgba(255,140,113,1), rgba(255,108,98,1));
    border-radius:20px;
    text-align: center;
    font-size: 40px;
    line-height: 90px;
    color: @color-white;
  }

  .popup-content {
    width: 590px;
    height: 640px;
    box-sizing: border-box;
    padding-top: 70px;
    background: #ffedc6;
    border-radius: 20px;
    &.disabled {
      background: #f5f6f7;
      .title {
        color: #333;
      }
      .hint {
        color: @color-text-light;
      }
    }
  }

</style>
